export const SESSION_REQUEST = 'sessions/SESSION_REQUEST';
export const SET_SESSION = 'sessions/SET_SESSION';
export const CLEAR_SESSION = 'sessions/CLEAR_SESSION';

export const WIZARD_SET = 'sessions/WIZARD_SET';
export const WIZARD_CLEAR = 'sessions/WIZARD_CLEAR';
